
export enum Currency {
  EUR = 'EUR',
  GBP = 'GBP',
  CHF = 'CHF',
  USD = 'USD',
  AUD = 'AUD',
  CZK = 'CZK',
  CAD = 'CAD',
  TRY = 'TRY',
  PLN = 'PLN',
  RUB = 'RUB',
}

export const currencyFrom = (currency?: string): Currency => {
  switch (currency) {
    case '€':
      return Currency.EUR
    case 'EUR':
      return Currency.EUR
    case 'CHF':
      return Currency.CHF
    case 'CHF ':
      return Currency.CHF
    case '£':
      return Currency.GBP
    case 'GBP':
      return Currency.GBP
    case '$':
      return Currency.USD
    case 'USD':
      return Currency.USD
    case 'A$':
      return Currency.AUD
    case 'AUD':
      return Currency.AUD
    case 'Kč':
      return Currency.CZK
    case 'CZK':
      return Currency.CZK
    case '₺':
      return Currency.TRY
    case 'zł':
      return Currency.PLN
    case '₽':
      return Currency.RUB
    case 'CAD':
    case 'C$':
    case 'CA$':
    case 'CAN$':
      return Currency.CAD
    default:
      return Currency.EUR
  }
}

export const currencySymbol = (currency: Currency): string => {
  switch (currency) {
    case Currency.EUR:
      return '€'
    case Currency.CHF:
      return 'CHF '
    case Currency.GBP:
      return '£'
    case Currency.USD:
      return '$'
    case Currency.AUD:
      return 'A$'
    case Currency.CZK:
      return 'Kč'
    case Currency.CAD:
      return 'C$'
    case Currency.TRY:
      return '₺'
    case Currency.PLN:
      return 'zł'
    case Currency.RUB:
      return '₽'
    default:
      return currency
  }
}
